import { CmsProduct } from '../../../../types/cmsProduct';
import { EligibilitySectionHeader } from './EligibilitySectionHeader';
import { TiEligibilityRowConfig } from './tiEligibility';
import { TiEligibilityList } from './TiEligibilityList';

type ProductDetailsSectionEligibilityTiProps = {
  product?: CmsProduct;
  rows?: TiEligibilityRowConfig[];
};

/**
 * TI provider page eligibility (M6): the editor-configured, text-capable list resolved against the
 * active tier's product.
 */
export const ProductDetailsSectionEligibilityTi: React.FC<
  ProductDetailsSectionEligibilityTiProps
> = ({
  product,
  rows,
}) => (
  <div className="flex flex-col gap-6" data-component="pdp-eligibility-ti">
    <EligibilitySectionHeader />
    <TiEligibilityList product={product} rows={rows} />
  </div>
);
